<cosmos-section
  sectionTitle="Elements"
  class="cosmos-cluster-details-modal__section"
>
  <cosmos-table
    [columns]="_columns"
    [dataSource]="_dataSource"
    [isFilterable]="false"
    [isPaginable]="false"
    (clickedRow)="openDetails($event)"
  ></cosmos-table>
</cosmos-section>
